import { apiClient } from "@/api/client";
import type { CustomRole, MyPageAccess } from "@/types/auth";

/** SUPER_ADMIN-defined admin roles, and each admin's own resolved sidebar. See admin.controller.ts's role routes. */
export const rolesApi = {
  /** GET /admin/my-page-access — every signed-in admin can read their own. */
  myPageAccess: () => apiClient.get<MyPageAccess>("/admin/my-page-access").then((r) => r.data),

  /** GET /admin/roles — SUPER_ADMIN only. */
  list: () => apiClient.get<CustomRole[]>("/admin/roles").then((r) => r.data),

  /** POST /admin/roles — SUPER_ADMIN only. */
  create: (payload: { name: string; pages: string[] }) =>
    apiClient.post<CustomRole>("/admin/roles", payload).then((r) => r.data),

  /** PATCH /admin/roles/:id — SUPER_ADMIN only. */
  update: (id: string, payload: Partial<{ name: string; pages: string[]; active: boolean }>) =>
    apiClient.patch<CustomRole>(`/admin/roles/${id}`, payload).then((r) => r.data),

  /** DELETE /admin/roles/:id — SUPER_ADMIN only; rejected while any admin is still assigned to it. */
  remove: (id: string) => apiClient.delete<void>(`/admin/roles/${id}`).then((r) => r.data),
};
